// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2FBY6","name":"Header_name__yLlMO","birthday":"Header_birthday__2IhZl","skeleton":"Header_skeleton__x2bER"};